<template>
    <vx-expandable-card>
        <template v-slot:header>
            <span class="align-middle">Account Status</span>
            <vx-badge size="sm" :color="teamData.status === 'active' ? 'success' : 'danger'" class="ml-4 capitalize align-middle">
                {{ teamData.status }}
            </vx-badge>
        </template>

        <template v-slot:content>
            <div class="flex justify-between items-center gap-2 mt-3">
                <vx-alert :color="teamData.status === 'active' ? 'success' : 'danger'" :closeable="false">
                    <template v-if="teamData.status === 'closed'">
                        This Account is permanently Closed. Further usage will require a new Account.
                    </template>
                    <template v-else>
                        <template v-if="impersonator">
                            <template v-if="teamData.status === 'active'">
                                This Account has been successfully activated.
                            </template>
                            <template v-else-if="teamData.status === 'suspended'">
                                Activate the Account if Suspension reasons have been rectified.
                            </template>
                            <template v-else>
                                Activate the Account for the first time once the Subscription and Payment Method are
                                validated.
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="teamData.status === 'active'">
                                Your account is Active, all capabilities are ready to be used.
                            </template>
                            <template v-else-if="teamData.status === 'suspended'">
                                Your Account is in Suspended status, please contact your Account Administrator to
                                rectify the account situation.
                            </template>
                            <template v-else>
                                Your Account is in pending status, our team needs to validate your plan and payment
                                method to proceed.
                            </template>
                        </template>
                    </template>
                    <template v-slot:right>
                        <div class="" v-if="impersonator && teamData.status !== 'closed'">
                            <vx-dropdown>
                                <vx-button
                                    type="button"
                                    size="sm"
                                    :color="teamData.status === 'active' ? 'success' : 'danger'"
                                    >Actions
                                </vx-button>
                                <template v-slot:items>
                                    <template v-for="status in statusActions" :key="status.type">
                                        <vx-dropdown-item
                                            :data-test="status.type"
                                            type="button"
                                            @click.prevent="status.method"
                                        >
                                            {{ status.name }}
                                        </vx-dropdown-item>
                                    </template>
                                </template>
                            </vx-dropdown>
                        </div>
                    </template>
                </vx-alert>
            </div>
            <kiosk-team-suspend-modal
                v-model:visible="modalSuspendConfirmVisible"
                v-model:team="teamData"
            ></kiosk-team-suspend-modal>
        </template>
    </vx-expandable-card>
</template>

<script>
import { adminTeamsClient } from '~/services';
import {VxButton,         VxAlert,
VxExpandableCard, VxDropdown, VxDropdownItem , VxBadge, VxSwal } from '@voxie/frontend-components';
import KioskTeamSuspendModal from '~/components/kiosk/kiosk-teams/modals/KioskTeamSuspendModal.vue';
import { throwSwalRequestError } from '~/utils/request';

export default {
    components: {
        KioskTeamSuspendModal,
        VxExpandableCard,
        VxBadge,
        VxAlert,
        VxButton,
        VxDropdown, VxDropdownItem
    },
    props: {
        team: {
            required: true
        },
        impersonator: {
            default: false
        }
    },
    data() {
        return {
            teamData: { ...this.team, status: this.team.status || 'pending' },
            modalActivateConfirmVisible: false,
            modalSuspendConfirmVisible: false,
        }
    },
    computed: {
        statusActions() {
            switch (this.teamData.status) {
                case 'suspended':
                case 'pending':
                    return [{ type: 'active', name: 'Activate', method: this.showModalActivateConfirm }]
                case 'active':
                    return [{ type: 'suspended', name: 'Suspend', method: this.showModalSuspendConfirm }]
                default:
                    return []
            }
        }
    },
    methods: {
        showModalSuspendConfirm() {
            this.modalSuspendConfirmVisible = true;
        },
        showModalActivateConfirm() {
            const title = this.teamData.status === 'suspended' ? 'Warning!' : 'Are you sure you want to proceed?';
            let html = '';

            if (this.teamData.status === 'suspended') {
                html = '<div class="flex flex-col text-left gap-3">' +
                    '   <p>Are you sure you want to proceed? By Activating this Account, the following will happen:</p>' +
                    '   <ul class="flex flex-col gap-2 list-disc pl-4">' +
                    '       <li>All current Owners and Members will recover their respective roles privileges.</li>' +
                    '       <li>All automated messaging capabilities will be resumed.</li>' +
                    '       <li>Notice: Messages scheduled to be sent during the suspended period are already discarded</li>' +
                    '   </ul>' +
                    '</div>';
            }

            VxSwal.fire({
                icon: 'warning',
                title: title,
                html: html,
                showCancelButton: true,
                preConfirm: () => adminTeamsClient.activateTeam(this.team.id)
                    .then(() => this.teamData.status = 'active')
                    .catch(throwSwalRequestError)
            });
        },
    }
};
</script>
